// @flow
import React, { Fragment } from "react";

import { DatePicker } from "sulu-admin-bundle/components";
import { translate } from "sulu-admin-bundle/utils";
import { AbstractFieldFilterType } from "sulu-admin-bundle/containers";
import dateFieldFilterTypeStyles from "./single-date.module.scss";
// import dateFieldFilterTypeStyles from './dateFieldFilterType.scss';
import type { ElementRef } from "react";

function formatDate(date: ?Date) {
    if (!date) {
        return "";
    }

    return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}

function formatDateTime(date: ?Date) {
    if (!date) {
        return "";
    }

    return date.toLocaleString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    });
}

class SingleDateField extends AbstractFieldFilterType<?{
    date?: Date,
}> {
    handleChange = (field: string, fieldValue: ?Date) => {
        const { onChange, value } = this;

        onChange({ ...value, date: fieldValue });
    };

    handleDateChange = (value: ?Date) => {
        this.handleChange("date", value);
    };

    setFromInputRef(ref: ?ElementRef<"input">) {
        if (ref) {
            ref.focus();
        }
    }

    getFormNode() {
        const { value } = this;

        return (
            <Fragment>
                <label className={dateFieldFilterTypeStyles.label}>Date</label>
                <DatePicker
                    className={dateFieldFilterTypeStyles.date}
                    inputRef={this.setFromInputRef}
                    onChange={this.handleDateChange}
                    options={{
                        dateFormat: true,
                        timeFormat: this.options.timeFormat,
                    }}
                    value={value ? value.date : undefined}
                />
            </Fragment>
        );
    }

    getValueNode(value: ?{ date?: Date }) {
        if (!value) {
            return Promise.resolve(null);
        }

        const { date } = value;
        const dateFormatter = this.options.timeFormat
            ? formatDateTime
            : formatDate;

        return Promise.resolve(dateFormatter(date));
    }
}

export default SingleDateField;
